document.addEventListener('DOMContentLoaded', function() {
  const previewElement = document.querySelector('.product-options__preview');
  const itemsContainer = document.querySelector('.product-options__items');
  let currentProductHandle = null;
  let currentVariantId = null;
  let currentClickedItem = null;

  // Cache items per row calculation
  let cachedItemsPerRow = null;
  let lastContainerWidth = 0;

  if (!previewElement || !itemsContainer) return;

  // Create "no results" message element
  const noResultsElement = document.createElement('div');
  noResultsElement.className = 'product-options__no-results';
  noResultsElement.innerHTML = '<p>Geen producten gevonden.</p>';
  noResultsElement.style.display = 'none';
  itemsContainer.parentNode.insertBefore(noResultsElement, itemsContainer.nextSibling);

  // Sort products by price (cheapest first)
  function sortByPrice(products) {
    return [...products].sort((a, b) => {
      const priceA = a.price || 0;
      const priceB = b.price || 0;
      return priceA - priceB;
    });
  }

  // Initialize: Update each item to use the smallest ML product as default
  function initializeItems() {
    const items = itemsContainer.querySelectorAll('.product-options__item');
    items.forEach(item => {
      try {
        const relatedProducts = JSON.parse(item.dataset.relatedProducts || '[]');
        if (relatedProducts.length > 0) {
          // Sort and get the first (smallest ML)
          const sortedProducts = sortByPrice(relatedProducts);
          const firstProduct = sortedProducts[0];

          // Update item data attributes with the smallest ML product
          item.dataset.productId = firstProduct.id;
          item.dataset.productUrl = firstProduct.url;
          item.dataset.productTitle = firstProduct.title;
          item.dataset.productArticle = firstProduct.article || '';

          // Update image URL if available
          if (firstProduct.image) {
            item.dataset.productImage = firstProduct.image;
          }

          // // Update price display
          // const priceContainer = item.querySelector('.product-options__item-price');
          // if (priceContainer) {
          //   priceContainer.innerHTML = `<span class="product-options__item-price-from">from: ${firstProduct.price_formatted}</span>`;
          // }
        }
      } catch (e) {
        console.error('Error initializing item:', e);
      }
    });
  }

  // Run initialization
  initializeItems();

  // Show More functionality
  const INITIAL_ITEMS_COUNT = 8;
  const showMoreWrapper = document.querySelector('.product-options__show-more-wrapper');
  const showMoreBtn = document.querySelector('[data-action="show-more"]');
  let isShowingAll = false;

  function initializeShowMore() {
    const items = itemsContainer.querySelectorAll('.product-options__item');

    if (items.length > INITIAL_ITEMS_COUNT) {
      // Hide items after the initial count
      items.forEach((item, index) => {
        if (index >= INITIAL_ITEMS_COUNT) {
          item.classList.add('is-hidden');
        }
      });

      // Show the "Show more" button
      if (showMoreWrapper) {
        showMoreWrapper.style.display = 'flex';
      }
    } else {
      // Hide the button if there are 8 or fewer items
      if (showMoreWrapper) {
        showMoreWrapper.style.display = 'none';
      }
    }
  }

  // Handle "Show more" button click
  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', function() {
      const items = itemsContainer.querySelectorAll('.product-options__item');

      if (!isShowingAll) {
        // Show all items
        items.forEach(item => {
          item.classList.remove('is-hidden');
        });
        showMoreBtn.textContent = 'Show less';
        isShowingAll = true;
      } else {
        // Hide items after initial count
        items.forEach((item, index) => {
          if (index >= INITIAL_ITEMS_COUNT) {
            item.classList.add('is-hidden');
          }
        });
        showMoreBtn.textContent = 'Show more';
        isShowingAll = false;

        // Scroll to the items container
        itemsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      // Update visible item indices
      updateVisibleItemIndices();
    });
  }

  // Initialize show more on page load
  initializeShowMore();

  // Set initial item indices for visible items
  updateVisibleItemIndices();

  // Filter functionality
  const filterColors = document.getElementById('filter-colors');
  const filterSeries = document.getElementById('filter-series');

  if (filterColors) {
    filterColors.addEventListener('change', function() {
      applyFilters();
    });
  }

  if (filterSeries) {
    filterSeries.addEventListener('change', function() {
      applyFilters();
    });
  }

  function applyFilters() {
    const colorValue = filterColors ? filterColors.value : '';
    const seriesValue = filterSeries ? filterSeries.value : '';
    const items = itemsContainer.querySelectorAll('.product-options__item');

    // Close preview when filtering
    if (previewElement.style.display !== 'none') {
      closePreview();
    }

    let visibleCount = 0;
    items.forEach(item => {
      const itemFilterName = item.dataset.filterName || '';
      const itemSeriesName = item.dataset.seriesName || '';
      let shouldShow = true;

      // Apply color filter
      if (colorValue && itemFilterName !== colorValue) {
        shouldShow = false;
      }

      // Apply series filter
      if (seriesValue && itemSeriesName !== seriesValue) {
        shouldShow = false;
      }

      item.style.display = shouldShow ? '' : 'none';

      // Apply show more logic to visible items
      if (shouldShow) {
        if (visibleCount >= INITIAL_ITEMS_COUNT && !isShowingAll) {
          item.classList.add('is-hidden');
        } else {
          item.classList.remove('is-hidden');
        }
        visibleCount++;
      }
    });

    // Show/hide "no results" message
    if (visibleCount === 0) {
      noResultsElement.style.display = 'block';
      itemsContainer.style.display = 'none';
    } else {
      noResultsElement.style.display = 'none';
      itemsContainer.style.display = '';
    }

    // Show/hide "Show more" button based on visible count
    if (showMoreWrapper) {
      if (visibleCount > INITIAL_ITEMS_COUNT) {
        showMoreWrapper.style.display = 'flex';
      } else {
        showMoreWrapper.style.display = 'none';
      }
    }

    // Reset show more state when filtering
    if (showMoreBtn) {
      showMoreBtn.textContent = 'Show more';
      isShowingAll = false;
    }

    // Recalculate item indices for visible items
    updateVisibleItemIndices();
  }

  function updateVisibleItemIndices() {
    const items = itemsContainer.querySelectorAll('.product-options__item');
    let visibleIndex = 0;

    items.forEach(item => {
      if (item.style.display !== 'none' && !item.classList.contains('is-hidden')) {
        item.dataset.itemIndex = visibleIndex;
        visibleIndex++;
      }
    });

    // Clear cache to force recalculation
    cachedItemsPerRow = null;
  }

  // Event delegation for better performance
  itemsContainer.addEventListener('click', function(e) {
    const button = e.target.closest('[data-action="toggle-preview"]');
    if (!button) return;

    e.preventDefault();
    const item = button.closest('.product-options__item');
    const productHandle = item.dataset.productHandle;
    const itemIndex = parseInt(item.dataset.itemIndex);

    if (currentProductHandle === productHandle && previewElement.style.display !== 'none') {
      closePreview();
    } else {
      currentClickedItem = item;
      loadProductData(item, itemIndex);
    }
  });

  // Handle close preview
  document.querySelector('[data-action="close-preview"]')?.addEventListener('click', closePreview);

  function loadProductData(item, itemIndex) {
    const productTitle = item.dataset.productTitle;
    const productImage = item.dataset.productImage;
    const productArticle = item.dataset.productArticle;
    const productUrl = item.dataset.productUrl;
    const productHandle = item.dataset.productHandle;
    const productId = item.dataset.productId;
    const lichtechtheid = item.dataset.lichtechtheid;
    const transparantie = item.dataset.transparantie;

    let relatedProducts = [];
    try {
      relatedProducts = JSON.parse(item.dataset.relatedProducts || '[]');
    } catch (e) {
      console.error('Error parsing related products:', e);
    }

    currentProductHandle = productHandle;
    populatePreview({
      id: productId,
      title: productTitle,
      image: productImage,
      article: productArticle,
      url: productUrl,
      lichtechtheid: lichtechtheid,
      transparantie: transparantie,
      relatedProducts: relatedProducts
    });
    positionAndShowPreview(itemIndex);
  }

  function populatePreview(data) {
    // Sort products first to get the first product (cheapest)
    const sortedProducts = data.relatedProducts && data.relatedProducts.length > 0
      ? sortByPrice(data.relatedProducts)
      : [];

    // Use first sorted product data if available, otherwise use data from item
    const firstProduct = sortedProducts[0] || {};
    const displayImage = firstProduct.image || data.image;
    const displayTitle = firstProduct.title || data.title;
    const displayArticle = firstProduct.article || data.article;
    const displayLichtwegheid = firstProduct.lichtechtheid || data.lichtechtheid;
    const displayTransparantie = firstProduct.transparantie || data.transparantie;

    // Set image
    const imageElement = document.getElementById('preview-image');
    if (displayImage) {
      imageElement.src = displayImage;
      imageElement.alt = displayTitle;
    }

    // Set title
    document.getElementById('preview-title').textContent = displayTitle;

    // Set article number
    const articleElement = document.getElementById('preview-article');
    if (displayArticle) {
      articleElement.textContent = 'Art. nr.: ' + displayArticle;
    } else {
      articleElement.textContent = '';
    }

    // Set characteristics (lightfastness & transparency)
    const characteristicsEl = document.getElementById('preview-characteristics');
    const lichtechtheidValueEl = document.getElementById('preview-lichtechtheid-value');
    const transparantieIconEl = document.getElementById('preview-transparantie-icon');
    const lightfastnessIconEl = document.getElementById('preview-lightfastness-icon');

    const hasLichtwegheid = displayLichtwegheid && displayLichtwegheid !== '0' && displayLichtwegheid !== '' && displayLichtwegheid !== null;
    const hasTransparantie = displayTransparantie && displayTransparantie !== '' && displayTransparantie !== null;

    if (hasLichtwegheid || hasTransparantie) {
      characteristicsEl.style.display = '';

      // Lightfastness value
      if (hasLichtwegheid) {
        lichtechtheidValueEl.textContent = displayLichtwegheid;
        lichtechtheidValueEl.style.display = '';
        lightfastnessIconEl.style.display = '';
      } else {
        lichtechtheidValueEl.style.display = 'none';
        lightfastnessIconEl.style.display = 'none';
      }

      // Transparency icon
      if (hasTransparantie) {
        const transparantieValue = displayTransparantie.toLowerCase();
        transparantieIconEl.className = 'product-options__characteristic';
        if (transparantieValue === 'transparant') {
          transparantieIconEl.classList.add('product-options__characteristic--transparent');
        } else if (transparantieValue === 'half transparant') {
          transparantieIconEl.classList.add('product-options__characteristic--semi-transparent');
        } else if (transparantieValue === 'dekkend') {
          transparantieIconEl.classList.add('product-options__characteristic--opaque');
        }
        transparantieIconEl.style.display = '';
      } else {
        transparantieIconEl.style.display = 'none';
      }
    } else {
      characteristicsEl.style.display = 'none';
    }

    // Populate variant table
    const formatsList = document.getElementById('preview-formats-list');
    if (formatsList && sortedProducts.length > 0) {

      formatsList.innerHTML = `
        <table class="product-options__variant-table">
          <thead>
            <tr>
              <th>SIZE</th>
              <th>SKU</th>
              <th>PRICE</th>
              <th class="product-options__variant-actions-col"></th>
            </tr>
          </thead>
          <tbody>
            ${sortedProducts.map((product, index) => {
              // Format size to add space between number and unit (e.g., 40ML -> 40 ML)
              let formattedSize = product.inhoud || product.title;
              formattedSize = formattedSize.replace(/(\d+)(ML|L|G|KG)/gi, '$1 $2');

              return `
              <tr class="product-options__variant-row" data-variant-id="${product.variantId}" data-product-image="${product.image || ''}" data-product-title="${product.title || ''}" data-product-article="${product.article || ''}" data-product-lichtechtheid="${product.lichtechtheid || ''}" data-product-transparantie="${product.transparantie || ''}">
                <td class="product-options__variant-size"><a href="${product.url}" class="product-options__variant-size-link" target="_blank" rel="noopener noreferrer">${formattedSize}</a></td>
                <td class="product-options__variant-sku">${product.article || '-'}</td>
                <td class="product-options__variant-price">${product.price_formatted}</td>
                <td class="product-options__variant-actions">
                  <div class="product-options__variant-controls">
                    <div class="product-options__quantity-selector product-options__quantity-selector--inline">
                      <button type="button" class="product-options__quantity-btn" data-action="decrease-variant-qty" data-row-index="${index}" aria-label="Decrease quantity">
                        <svg width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M1 1H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                      </button>
                      <input type="number" class="product-options__quantity-input product-options__quantity-input--inline" value="1" min="1" data-row-index="${index}" aria-label="Quantity">
                      <button type="button" class="product-options__quantity-btn" data-action="increase-variant-qty" data-row-index="${index}" aria-label="Increase quantity">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M6 1V11M1 6H11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                      </button>
                    </div>
                    <button type="button" class="product-options__add-variant-btn" data-variant-id="${product.variantId}" data-row-index="${index}">
                      ADD TO BASKET
                    </button>
                  </div>
                </td>
              </tr>
            `;
            }).join('')}
          </tbody>
        </table>
      `;

      // Add event listeners for quantity buttons
      formatsList.querySelectorAll('[data-action="decrease-variant-qty"]').forEach(btn => {
        btn.addEventListener('click', function() {
          const rowIndex = this.dataset.rowIndex;
          const input = formatsList.querySelector(`input[data-row-index="${rowIndex}"]`);
          const currentValue = parseInt(input.value) || 1;
          if (currentValue > 1) {
            input.value = currentValue - 1;
          }
        });
      });

      formatsList.querySelectorAll('[data-action="increase-variant-qty"]').forEach(btn => {
        btn.addEventListener('click', function() {
          const rowIndex = this.dataset.rowIndex;
          const input = formatsList.querySelector(`input[data-row-index="${rowIndex}"]`);
          const currentValue = parseInt(input.value) || 1;
          input.value = currentValue + 1;
        });
      });

      // Add event listeners for "Add to Basket" buttons
      formatsList.querySelectorAll('.product-options__add-variant-btn').forEach(btn => {
        btn.addEventListener('click', function() {
          const variantId = this.dataset.variantId;
          const rowIndex = this.dataset.rowIndex;
          const input = formatsList.querySelector(`input[data-row-index="${rowIndex}"]`);
          const quantity = parseInt(input.value) || 1;
          addToCart(variantId, quantity, this);  // Pass button element (this)
        });
      });

      // Add event listeners for row click to change preview image
      formatsList.querySelectorAll('.product-options__variant-row').forEach(row => {
        row.addEventListener('click', function(e) {
          // Ignore clicks on links
          if (e.target.closest('.product-options__variant-size-link')) {
            return;
          }

          const productImage = this.dataset.productImage;
          const productTitle = this.dataset.productTitle;
          const productArticle = this.dataset.productArticle;
          const productLichtwegheid = this.dataset.productLichtwegheid;
          const productTransparantie = this.dataset.productTransparantie;

          // Update image
          if (productImage) {
            const imageElement = document.getElementById('preview-image');
            imageElement.src = productImage;
            imageElement.alt = productTitle || '';
          }

          // Update title
          if (productTitle) {
            document.getElementById('preview-title').textContent = productTitle;
          }

          // Update article number
          const articleElement = document.getElementById('preview-article');
          if (productArticle) {
            articleElement.textContent = 'Art. nr.: ' + productArticle;
          } else {
            articleElement.textContent = '';
          }

          // Update color fastness
          const characteristicsEl = document.getElementById('preview-characteristics');
          const lichtechtheidValueEl = document.getElementById('preview-lichtechtheid-value');
          const transparantieIconEl = document.getElementById('preview-transparantie-icon');
          const lightfastnessIconEl = document.getElementById('preview-lightfastness-icon');

          const hasLichtwegheid = productLichtwegheid && productLichtwegheid !== '0' && productLichtwegheid !== '' && productLichtwegheid !== 'null';
          const hasTransparantie = productTransparantie && productTransparantie !== '' && productTransparantie !== 'null';

          if (hasLichtwegheid || hasTransparantie) {
            characteristicsEl.style.display = '';

            if (hasLichtwegheid) {
              lichtechtheidValueEl.textContent = productLichtwegheid;
              lichtechtheidValueEl.style.display = '';
              lightfastnessIconEl.style.display = '';
            } else {
              lichtechtheidValueEl.style.display = 'none';
              lightfastnessIconEl.style.display = 'none';
            }

            if (hasTransparantie) {
              const transparantieValue = productTransparantie.toLowerCase();
              transparantieIconEl.className = 'product-options__characteristic';
              if (transparantieValue === 'transparant') {
                transparantieIconEl.classList.add('product-options__characteristic--transparent');
              } else if (transparantieValue === 'half transparant') {
                transparantieIconEl.classList.add('product-options__characteristic--semi-transparent');
              } else if (transparantieValue === 'dekkend') {
                transparantieIconEl.classList.add('product-options__characteristic--opaque');
              }
              transparantieIconEl.style.display = '';
            } else {
              transparantieIconEl.style.display = 'none';
            }
          } else {
            characteristicsEl.style.display = 'none';
          }

          // Update active state
          formatsList.querySelectorAll('.product-options__variant-row').forEach(r => {
            r.classList.remove('is-active');
          });
          this.classList.add('is-active');
        });
      });

      // Set first row as active by default
      const firstRow = formatsList.querySelector('.product-options__variant-row');
      if (firstRow) {
        firstRow.classList.add('is-active');
      }
    }
  }

  async function addToCart(variantId, quantity, buttonElement) {
    try {
      // Disable button and add loading class
      buttonElement.setAttribute('disabled', 'disabled');
      buttonElement.classList.add('is-loading');

      // Dispatch loading start event
      document.dispatchEvent(new CustomEvent('theme:loading:start'));

      const response = await fetch(`${window.routes.cartAddUrl}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      });

      if (!response.ok) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        const content = await response.json();

        // Re-enable button on error
        buttonElement.removeAttribute('disabled');
        buttonElement.classList.remove('is-loading');

        throw new Error(content['description'] || 'Failed to add to cart');
      }

      const result = await response.json();

      // Re-enable button on success
      buttonElement.removeAttribute('disabled');
      buttonElement.classList.remove('is-loading');

      // Dispatch product:added event on document.documentElement to match theme's listener
      // The theme listens on delegateRoot which is document.documentElement
      document.documentElement.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: result,
          quantity: quantity,
          button: buttonElement  // Pass button element like ProductForm does
        }
      }));

      console.log('Added to cart:', result);

    } catch (error) {
      console.error('Error adding to cart:', error);

      // Ensure button is re-enabled on any error
      buttonElement.removeAttribute('disabled');
      buttonElement.classList.remove('is-loading');

      // Show error message
      alert(error.message || 'Failed to add product to cart. Please try again.');
    }
  }


  // Helper: get truly visible items (not hidden by filter OR show-more)
  function getVisibleItems() {
    return Array.from(itemsContainer.querySelectorAll('.product-options__item')).filter(item => {
      return item.style.display !== 'none' && !item.classList.contains('is-hidden');
    });
  }

  function positionAndShowPreview(itemIndex) {
    const visibleItems = getVisibleItems();
    if (visibleItems.length === 0) return;

    const itemsPerRow = getItemsPerRow();

    // Calculate which row the clicked item is in (0-based)
    const clickedRow = Math.floor(itemIndex / itemsPerRow);

    // Find the last item in that row (within visible items only)
    const lastItemIndexInRow = Math.min((clickedRow + 1) * itemsPerRow - 1, visibleItems.length - 1);
    const lastItemInRow = visibleItems[lastItemIndexInRow];

    // Insert preview after the last item in the row
    if (lastItemInRow && lastItemInRow.nextSibling !== previewElement) {
      lastItemInRow.after(previewElement);
    }

    // Show preview with requestAnimationFrame for smoother animation
    requestAnimationFrame(() => {
      previewElement.style.display = 'block';

      requestAnimationFrame(() => {
        previewElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    });
  }

  function getItemsPerRow() {
    const containerWidth = itemsContainer.offsetWidth;

    // Return cached value if container width hasn't changed
    if (cachedItemsPerRow !== null && lastContainerWidth === containerWidth) {
      return cachedItemsPerRow;
    }

    const visibleItems = getVisibleItems();
    if (visibleItems.length === 0) return 1;

    // Count items in first row by comparing offsetTop (more accurate than gap calculation)
    const firstItemTop = visibleItems[0].offsetTop;
    let itemsInFirstRow = 0;

    for (let i = 0; i < visibleItems.length; i++) {
      if (visibleItems[i].offsetTop === firstItemTop) {
        itemsInFirstRow++;
      } else {
        break;
      }
    }

    const itemsPerRow = itemsInFirstRow || 1;

    // Cache the result
    cachedItemsPerRow = itemsPerRow;
    lastContainerWidth = containerWidth;

    return itemsPerRow;
  }

  function closePreview() {
    previewElement.style.display = 'none';
    currentProductHandle = null;
    currentVariantId = null;
    currentClickedItem = null;
  }

  // Optimized resize handler with passive listener
  let resizeTimeout;
  let ticking = false;

  window.addEventListener('resize', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        // Clear cache on resize
        cachedItemsPerRow = null;

        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
          if (currentClickedItem && previewElement.style.display !== 'none') {
            const itemIndex = parseInt(currentClickedItem.dataset.itemIndex);
            positionAndShowPreview(itemIndex);
          }
        }, 150);

        ticking = false;
      });

      ticking = true;
    }
  }, { passive: true });
});
